<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-brand">
        <router-link to="/" class="brand-link">
          <img src="@/assets/vpn/vpn-logo.webp" alt="Secure VPN">
          <span>Secure VPN</span>
        </router-link>
      </div>
      <div class="footer-links">
        <router-link to="/about-us/" class="footer-link">{{ navCopy.about }}</router-link>
        <router-link to="/contact-us/" class="footer-link">{{ navCopy.contact }}</router-link>
        <router-link to="/privacy-policy/" class="footer-link">{{ navCopy.privacy }}</router-link>
        <router-link to="/terms-of-use/" class="footer-link">{{ navCopy.terms }}</router-link>
        <router-link to="/disclaimer/" class="footer-link">{{ navCopy.disclaimer }}</router-link>
      </div>
      <p class="footer-copy">&copy; 2026 <router-link to="/" class="footer-link">secureproxyvpn.com</router-link>. {{ navCopy.footer }}</p>
    </div>
  </footer>
</template>

<script>
import '@/css/vpn-theme.scss';
import { getNavigationCopy } from '@/documents/vpnNavigation';

export default {
  name: 'Footer',
  computed: {
    navCopy() {
      return getNavigationCopy(this.$route.meta.localeKey || 'en');
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background:
    linear-gradient(180deg, #12122e, #1e1b4b);
  color: rgba(255, 255, 255, 0.78);
  padding: 18px 0 16px;
  font-family: var(--vpn-font);
}

.footer-container {
  width: var(--vpn-container);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.brand-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
}

.brand-link img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.footer-brand {
  display: flex;
  justify-content: center;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  justify-content: center;
}

.footer-link {
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
  font-size: 12px;
  font-weight: 600;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: var(--vpn-teal-bright);
}

.footer-copy {
  max-width: 100%;
  margin: 0;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.58);
}

@media (max-width: 860px) {
  .footer {
    padding: 16px 0 14px;
  }

  .footer-container {
    gap: 7px;
  }

  .footer-links {
    gap: 6px 12px;
  }
}
</style>
